import { xMultiply } from "./xMultiply.js";
/**
 * Dot product between two arrays.
 * @param A - First array.
 * @param B - Second array.
 */
export function xDotProduct(A, B) {
    const g = xMultiply(A, B);
    let result = 0;
    for (let i = 0; i < A.length; i++) {
        result += g[i];
    }
    return result;
}
//# sourceMappingURL=xDotProduct.js.map